/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { useRef } from 'react'
import { FormikProps } from 'formik'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Lightbox } from '@nexigendigital/nxui'
import { useUpdateDomainContactsMutation } from 'api/domain'
import { Address } from 'models/account'
import { DomainContactType } from 'models/domain'
import { titleCase } from 'helpers/utils'

import DomainContactForm from 'containers/domains/forms/domainContactForm'

/**********************************************************************************************************
 *   INTERFACE
 **********************************************************************************************************/
interface Props {
    type: DomainContactType
    contact: Address,
    status: boolean,
    close: () => void
}

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function DomainContactLightbox({ type, contact, status, close }: Props) {
    const formRef = useRef<FormikProps<Address>>(null)
    const [, { isLoading }] = useUpdateDomainContactsMutation({ fixedCacheKey: 'update-domain-contact' })

    /*   RENDER COMPONENT
    **********************************************************************************************************/
    return (
        <Lightbox
            title={`Edit ${titleCase(type)} Contact`}
            content={<DomainContactForm type={type} form={formRef} contact={contact} close={close}/>}
            conditions={{ state: status, action: () => close() }}
            actions={[
                {
                    label: 'Back',
                    color: 'flat',
                    func: () => close()
                },
                {
                    label: 'Update',
                    color: 'primary',
                    type: 'submit',
                    loading: isLoading ? 'Updating Contact...' : false,
                    form: 'updateDomainContactForm'
                }
            ]}
        />
    )
}
